import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { enableAnalytics, disableAnalytics } from '../../services/google/analytics/actions';

import { GA_TRACKING_NUMBER_PLEBICOM } from '../../constants';

const AnalyticsComponent = ({
    history,
    enable,
    isInitialized,
    enableAnalytics,
    disableAnalytics
}) => {
    useEffect(() => {
        const { pathname, hash } = history.location;

        const deleteAnalyticsCookies = () => {
            document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        };

        if (enable) {
            if (!isInitialized) {
                ReactGA.initialize(GA_TRACKING_NUMBER_PLEBICOM, {
                    gaOptions: {
                        cookieExpires: 15768000 // 6 mois en secondes
                    }
                });
                enableAnalytics();
            }

            const path = pathname + hash;
            ReactGA.send({ hitType: 'pageview', page: path });
        } else {
            if (isInitialized) {
                disableAnalytics();
            }
            deleteAnalyticsCookies();
        }
    }, [enable, history.location, isInitialized, disableAnalytics, enableAnalytics]);

    return null;
};

const mapStateToProps = state => {
    return {
        isInitialized: state.google.analytics.enabled
    };
};

const mapDispatchToProps = {
    enableAnalytics,
    disableAnalytics
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnalyticsComponent));



// WEBPACK FOOTER //
// ./src/components/google/AnalyticsComponent.js